// モックアップ共有（doc/design/pm-mockup.md）
export default {
  'mockup.tab': 'Mockups',
  'mockup.empty': 'No mockups yet',
  'mockup.chip.internal': 'Internal only',
  'mockup.chip.shared': 'Shared',
  'mockup.chip.sharedUntil': 'Shared · until {date}',
  'mockup.col.title': 'Title',
  'mockup.col.linked': 'Linked to',
  'mockup.col.version': 'Ver.',
  'mockup.col.share': 'Sharing',
  'mockup.col.updated': 'Updated',
  'mockup.linked.task': 'Task',
  'mockup.linked.bug': 'Bug',
  'mockup.linked.project': 'Project only',
  'mockup.deleteConfirm': 'Delete “{title}”?',
  'mockup.deleteHint':
    'All versions will be deleted and the share link will stop working.',
  'mockup.edit.title': 'Edit mockup',
  'mockup.edit.task': 'Linked task',
  'mockup.edit.taskHint':
    'Leave empty to attach it to the whole project. To change the content, publish a new version.',
  'mockup.edit.clearBug': 'Unlink from bug {bug}',
  'mockup.field.title': 'Title',
  'mockup.field.titlePlaceholder': 'Leave empty to use the HTML title tag',
  'mockup.field.note': 'Change note',
  'mockup.field.notePlaceholder':
    'e.g. Added the “On hold” status per client feedback',
  'mockup.page.title': 'Mockups',
  'mockup.page.titleOf': '{name} · Mockups',
  'mockup.page.subtitle':
    'Version and share HTML mockups made with Claude Code and similar tools',
  'mockup.page.sharedOnly': 'Shared only',
  'mockup.page.upload': 'Upload HTML / zip',
  'mockup.page.entry': 'Mockups',
  'mockup.upload.title': 'Publish mockup',
  'mockup.upload.newVersion': 'Upload a new version',
  'mockup.upload.publish': 'Publish',
  'mockup.upload.drop': 'Drop an HTML or zip file, or click to choose',
  'mockup.upload.hint':
    '.html (up to 5 MB) or a .zip with images etc. (up to 50 MB)',
  'mockup.upload.needFile': 'Choose an HTML or zip file',
  'mockup.upload.done': 'Published v{v}',
  'mockup.upload.error.type': 'Only .html or .zip files can be uploaded',
  'mockup.upload.error.size':
    "HTML files over 5 MB can't be uploaded. Split images etc. into a zip",
  'mockup.upload.error.zipSize': "Zip files over 50 MB can't be uploaded",
  'mockup.upload.error.empty': 'The file is empty',
  'mockup.viewer.close': 'Close',
  'mockup.viewer.desktop': 'Desktop',
  'mockup.viewer.tablet': 'Tablet',
  'mockup.viewer.phone': 'Phone',
  'mockup.viewer.openTab': 'Open in new tab',
  'mockup.viewer.newVersion': 'New version',
  'mockup.viewer.share': 'Share…',
  'mockup.viewer.loading': 'Loading…',
  'mockup.viewer.slow':
    'This is taking longer than usual. Please wait a moment.',
  'mockup.version.files': '{n} files',
  'mockup.version.title': 'Versions',
  'mockup.version.deleteConfirm': 'Delete v{v}?',
  'mockup.version.deleteHint':
    'If you delete the current version, the latest remaining one becomes current.',
  'mockup.version.shareLatest':
    'The share link always shows the latest version.',
  'mockup.version.sharePinned': 'The share link is pinned to v{v}.',
  'mockup.version.notShared': 'No share link yet.',
  'mockup.share.title': 'Share “{title}”',
  'mockup.share.enable': 'Share link on',
  'mockup.share.offHint':
    'Turning this on issues a link that works without login (30 days by default).',
  'mockup.share.link': 'Link (no login needed)',
  'mockup.share.copy': 'Copy',
  'mockup.share.copied': 'Copied',
  'mockup.share.copyFailed': "Couldn't copy",
  'mockup.share.expiry': 'Expires',
  'mockup.share.days7': '7 days',
  'mockup.share.days30': '30 days',
  'mockup.share.never': 'Never',
  'mockup.share.until': 'Until {date}',
  'mockup.share.noExpiry': 'No expiry',
  'mockup.share.version': 'Version shown',
  'mockup.share.latest': 'Always latest',
  'mockup.share.pinTo': 'Pin to v{v}',
  'mockup.share.views': 'Opened {n} times · last {last}',
  'mockup.share.regenerate': 'Regenerate link',
  'mockup.share.regenerateConfirm': 'Regenerate the link?',
  'mockup.share.regenerateHint':
    'The current link stops working immediately. Send the new link to your recipients.',
  'mockup.share.regenerated': 'New link issued',
  'mockup.share.done': 'Done',
  'mockup.public.invalid':
    'This link is no longer valid. Please contact your representative.',
  'mockup.public.version': 'Version {v} · updated {date}',
  'mockup.public.validUntil': 'Valid until {date}',
};
